module.exports = __webpack_public_path__ + "img/kv_fw1.ba98a0ad.png";